import { useState } from "react"

import { Checkbox } from "antd"

// Always mounted checked. Keeps its own state when `checked` is not passed, so it also works
// inside `modal.confirm` content, which is rendered once and can't react to outer state.
export const NotifyMerchantCheckbox = ({ checked, onChange }) => {
  const [internalChecked, setInternalChecked] = useState(true)
  const isControlled = checked !== undefined

  return (
    <Checkbox
      checked={isControlled ? checked : internalChecked}
      onChange={(e) => {
        if (!isControlled) setInternalChecked(e.target.checked)
        onChange?.(e.target.checked)
      }}
    >
      Notify merchant by email
    </Checkbox>
  )
}
